var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUltimo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1113,
    height: 478,
    viewBox: "0 0 1113 478",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M760.177 358.891C750.626 399.83 737.735 432.107 680.018 431.163C620.259 432.107 610.019 404.473 599.86 358.891H760.177Z",
    fill: "#2C2C2B",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M760.177 358.891C751.101 397.779 739.022 428.867 688.322 431.048C657.756 429.136 631.769 402.83 622.861 358.891H760.177Z",
    fill: "#171717",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M692.873 400.36C696.848 400.36 700.07 397.504 700.07 393.981C700.07 390.458 696.848 387.602 692.873 387.602C688.899 387.602 685.677 390.458 685.677 393.981C685.677 397.504 688.899 400.36 692.873 400.36Z",
    fill: "#D9E3F0",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M222.491 374.906C211.723 421.065 197.188 457.46 132.112 456.394C64.7327 457.46 53.189 426.303 41.7326 374.906H222.491Z",
    fill: "#2C2C2B",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M222.491 374.896C212.258 418.744 198.637 453.795 141.476 456.254C107.011 454.098 77.7104 424.438 67.6677 374.896H222.492H222.491Z",
    fill: "#171717",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M144.108 406.256C148.59 406.256 152.223 403.035 152.223 399.062C152.223 395.09 148.59 391.869 144.108 391.869C139.626 391.869 135.993 395.09 135.993 399.062C135.993 403.035 139.626 406.256 144.108 406.256Z",
    fill: "#D9E3F0",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1087.37 322.943C1087.37 331.385 1090.51 441.113 993.87 441.113C919.533 440.341 906.99 387.249 906.99 325.033C906.99 262.817 943.432 212.38 993.87 212.38C1061.08 212.38 1087.37 203.053 1087.37 322.943Z",
    fill: "#171717",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.87 433.741C1057.25 433.741 1083.5 389.351 1083.5 334.592C1083.5 279.834 1057.25 235.443 1024.87 235.443C992.488 235.443 966.238 279.834 966.238 334.592C966.238 389.351 992.488 433.741 1024.87 433.741Z",
    fill: "#373736",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1071.91 333.941C1071.91 377.518 1050.57 412.844 1024.25 412.844C1000.34 412.844 977.823 376.959 977.823 333.383C977.823 289.806 999.051 254.582 1024.25 255.038C1048.58 255.478 1071.91 290.363 1071.91 333.94V333.941Z",
    fill: "#1A1A1A",
    stroke: "white",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1071.89 334.802L1045.37 346.248L1062.86 380.159C1057.19 393.181 1049.16 403.188 1039.8 408.534L1024.46 371.008L1008.34 407.558C998.129 400.686 989.219 387.544 983.701 370.923L996.484 347.533L977.875 336.601C977.841 335.539 977.824 334.459 977.824 333.38C977.824 315.422 981.439 298.869 987.437 285.658L1010.95 302.828V258.191C1015.18 256.066 1019.65 254.952 1024.24 255.038C1029.37 255.123 1034.44 256.734 1039.25 259.63V298.321L1061.27 285.675C1067.83 298.972 1071.91 315.679 1071.91 333.928C1071.91 334.219 1071.91 334.511 1071.89 334.802Z",
    fill: "#F2F2F2",
    stroke: "#F2F2F2",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M999.235 334.974L978.194 322.037C979.033 312.201 980.97 302.965 983.78 294.672L1011.28 312.287V329.422L999.235 334.974Z",
    stroke: "white",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1012.02 342.123L1020.45 364.399L1003.55 403.912C998.379 399.269 993.667 392.997 989.726 385.509L1012.02 342.123Z",
    stroke: "white",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.73 321.214L1016.59 309.391V255.981C1019.04 255.313 1021.56 254.987 1024.11 255.038C1027.61 255.09 1031.07 255.861 1034.45 257.283V305.296L1019.73 321.214Z",
    stroke: "white",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1041.28 349.675L1059.09 387.492C1055.27 394.398 1050.67 400.155 1045.55 404.405L1025.04 360.933L1023.76 340.199L1041.28 349.675Z",
    stroke: "white",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.56 326.282L1038.3 311.563L1066.13 297.924C1069.01 306.577 1070.91 316.19 1071.54 326.402L1044.57 337.609L1024.56 326.282Z",
    stroke: "white",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1034.45 257.283V305.296L1019.73 321.214L1016.59 309.391V255.981C1019.04 255.313 1021.56 254.987 1024.11 255.038C1027.61 255.09 1031.07 255.861 1034.45 257.283Z",
    fill: "#1A1A1A",
    stroke: "#F2F2F2",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1071.54 326.402L1044.57 337.609L1024.56 326.282L1038.3 311.563L1066.13 297.924C1069.01 306.577 1070.91 316.19 1071.54 326.402Z",
    fill: "#1A1A1A",
    stroke: "#F2F2F2",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1011.28 312.287V329.422L999.235 334.974L978.194 322.037C979.033 312.201 980.97 302.965 983.78 294.672L1011.28 312.287Z",
    fill: "#1A1A1A",
    stroke: "#F2F2F2",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.45 364.399L1003.55 403.912C998.379 399.269 993.667 392.997 989.726 385.509L1012.02 342.123L1020.45 364.399Z",
    fill: "#1A1A1A",
    stroke: "#F2F2F2",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1059.09 387.492C1055.27 394.398 1050.67 400.155 1045.55 404.405L1025.04 360.933L1023.76 340.199L1041.28 349.675L1059.09 387.492Z",
    fill: "#1A1A1A",
    stroke: "#F2F2F2",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1017.98 339.747C1020.92 339.747 1023.31 336.897 1023.31 333.381C1023.31 329.866 1020.92 327.016 1017.98 327.016C1015.04 327.016 1012.65 329.866 1012.65 333.381C1012.65 336.897 1015.04 339.747 1017.98 339.747Z",
    fill: "#FDFDFE",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1017.98 337.78C1020.02 337.78 1021.67 335.807 1021.67 333.374C1021.67 330.941 1020.02 328.969 1017.98 328.969C1015.94 328.969 1014.29 330.941 1014.29 333.374C1014.29 335.807 1015.94 337.78 1017.98 337.78Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M578.468 341.026C578.468 350.693 584.021 476.337 473.37 476.337C388.251 475.451 373.887 414.66 373.887 343.419C373.887 272.178 415.614 214.426 473.37 214.426C550.322 214.426 578.468 203.746 578.468 341.026Z",
    fill: "#171717",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M490.559 473.288C531.192 473.288 564.132 424.367 564.132 364.019C564.132 303.671 531.192 254.75 490.559 254.75C449.925 254.75 416.985 303.671 416.985 364.019C416.985 424.367 449.925 473.288 490.559 473.288Z",
    fill: "#373736",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M549.598 363.302C549.598 411.327 522.818 450.258 489.782 450.258C459.777 450.258 431.524 410.712 431.524 362.687C431.524 314.663 458.162 275.843 489.782 276.347C520.313 276.832 549.598 315.278 549.598 363.302Z",
    fill: "#1A1A1A",
    stroke: "#F2F2F2",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M549.572 364.262L516.286 376.876L538.239 414.248C531.122 428.601 521.038 439.629 509.297 445.52L490.053 404.164L469.82 444.444C457.005 436.872 445.825 422.387 438.9 404.07L454.94 378.294L431.589 366.246C431.546 365.075 431.524 363.885 431.524 362.695C431.524 342.904 436.061 324.662 443.587 310.103L473.088 329.025V279.832C478.4 277.489 484.011 276.262 489.774 276.357C496.203 276.451 502.566 278.226 508.61 281.418V324.059L536.24 310.123C544.475 324.777 549.593 343.189 549.593 363.3C549.593 363.621 549.593 363.941 549.572 364.262Z",
    fill: "#F2F2F2",
    stroke: "#F2F2F2",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M458.391 364.459L431.987 350.201C433.04 339.361 435.47 329.183 438.996 320.043L473.508 339.455V358.34L458.391 364.459Z",
    stroke: "white",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M474.433 372.338L485.012 396.887L463.812 440.435C457.318 435.316 451.404 428.406 446.459 420.153L474.433 372.34V372.338Z",
    stroke: "white",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M484.11 349.288L480.176 336.258V277.396C483.25 276.659 486.412 276.301 489.616 276.357C494.002 276.414 498.346 277.264 502.582 278.832V331.745L484.11 349.288Z",
    stroke: "white",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M511.159 380.651L533.5 422.329C528.705 429.939 522.943 436.284 516.512 440.967L490.774 393.059L489.162 370.209L511.159 380.651Z",
    stroke: "white",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M490.172 354.889L507.416 338.668L542.335 323.637C545.947 333.172 548.334 343.767 549.129 355.021L515.285 367.372L490.17 354.889H490.172Z",
    stroke: "white",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M502.58 278.832V331.745L484.11 349.288L480.176 336.258V277.396C483.25 276.659 486.412 276.301 489.616 276.357C494.002 276.414 498.346 277.264 502.582 278.832H502.58Z",
    fill: "#1A1A1A",
    stroke: "#F2F2F2",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M549.13 355.021L515.286 367.372L490.171 354.889L507.416 338.668L542.335 323.637C545.947 333.172 548.334 343.767 549.129 355.021H549.13Z",
    fill: "#1A1A1A",
    stroke: "#F2F2F2",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M473.508 339.455V358.34L458.391 364.459L431.987 350.201C433.04 339.361 435.47 329.183 438.996 320.043L473.508 339.455Z",
    fill: "#1A1A1A",
    stroke: "#F2F2F2",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M485.012 396.886L463.812 440.433C457.318 435.315 451.404 428.404 446.459 420.152L474.433 372.338L485.012 396.887V396.886Z",
    fill: "#1A1A1A",
    stroke: "#F2F2F2",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M533.5 422.329C528.705 429.939 522.943 436.284 516.512 440.967L490.774 393.059L489.162 370.209L511.158 380.651L533.5 422.329Z",
    fill: "#1A1A1A",
    stroke: "#F2F2F2",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M481.918 369.718C485.611 369.718 488.605 366.577 488.605 362.703C488.605 358.828 485.611 355.688 481.918 355.688C478.224 355.688 475.23 358.828 475.23 362.703C475.23 366.577 478.224 369.718 481.918 369.718Z",
    fill: "#FDFDFE",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M481.917 367.548C484.473 367.548 486.546 365.374 486.546 362.692C486.546 360.01 484.473 357.836 481.917 357.836C479.361 357.836 477.289 360.01 477.289 362.692C477.289 365.374 479.361 367.548 481.917 367.548Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1107.87 292.754C1114.14 222.798 1107.63 214.356 1107.63 214.356C1106.66 174.071 1102.8 151.394 1102.8 151.394C1099.67 138.85 1043.38 79.5895 1043.38 79.5895C1046.6 76.6954 1029.63 59.6477 1029.63 59.6477C1011.86 40.3501 930.248 23.6245 930.248 23.6245C725.691 -14.3281 501.996 -0.979839 423.517 33.1122C345.04 67.206 255.425 133.384 255.425 133.384C76.9198 145.928 54.2453 179.7 54.2453 179.7C3.10656 202.536 8.73534 236.146 8.73534 236.146C1.65867 242.579 1.17718 253.515 1.17718 253.515V362.067C-0.752195 370.751 3.42869 379.677 6.64489 384.502C9.86109 389.328 39.9344 397.367 39.9344 397.367L209.756 403.8C231.948 404.122 315.251 408.785 342.912 411.036C370.572 413.288 390.834 404.443 395.981 402.191C401.127 399.939 405.308 389.326 406.917 380.962C408.526 372.6 406.434 364.72 406.434 364.72C413.51 211.621 522.966 221.94 548.858 255.069C582.468 293.666 577.65 362.146 577.007 373.404C576.365 384.662 568.22 405.085 568.22 405.085C568.22 405.085 935.678 387.153 941.467 386.913C947.257 386.672 952.161 366.971 952.161 366.971C957.629 345.1 957.307 329.541 957.307 329.541C963.861 285.227 976.165 257.687 990.457 241.421C990.404 204.481 978.873 159.955 975.022 150.006C978.873 159.955 990.406 204.481 990.457 241.421C1012.81 213.257 1056.55 222.264 1069.74 242.848C1094.5 275.977 1085.03 344.699 1085.03 344.699C1085.03 344.699 1097.98 334.97 1102.81 330.145C1107.63 325.319 1110.52 313.5 1111.97 306.986C1113.42 300.473 1107.87 292.754 1107.87 292.754H1107.87ZM602.776 353.585C602.158 351.618 602.214 348.601 602.214 348.601C608.969 213.996 601.577 170.875 595.017 162.895C601.575 170.875 608.969 213.996 602.214 348.601C602.214 348.601 602.159 351.62 602.776 353.585ZM806.082 317.259C808.976 332.376 807.369 364.54 805.439 376.118C807.369 364.54 808.978 332.376 806.082 317.259C803.188 302.142 807.047 296.352 807.047 296.352C807.047 296.352 803.186 302.142 806.082 317.259Z",
    fill: "#878787"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M990.457 241.421C976.165 257.687 963.861 285.227 957.307 329.541C957.307 329.541 957.629 345.1 952.161 366.971C952.161 366.971 947.257 386.672 941.467 386.913C935.678 387.153 568.22 405.085 568.22 405.085C568.22 405.085 576.365 384.662 577.007 373.404C577.65 362.146 582.468 293.666 548.858 255.069C522.966 221.94 413.51 211.621 406.434 364.72C406.434 364.72 408.526 372.6 406.917 380.962C405.308 389.326 401.127 399.939 395.981 402.191C390.834 404.443 370.572 413.288 342.912 411.036C315.251 408.785 231.948 404.122 209.756 403.8L39.9344 397.367C39.9344 397.367 9.86109 389.328 6.64489 384.502C3.42869 379.677 -0.752195 370.751 1.17718 362.067V253.515C1.17718 253.515 1.65867 242.579 8.73534 236.146C8.73534 236.146 3.10656 202.536 54.2453 179.7C54.2453 179.7 76.9198 145.928 255.425 133.384C255.425 133.384 345.04 67.206 423.517 33.1122C501.996 -0.979839 725.691 -14.3281 930.248 23.6245C930.248 23.6245 1011.86 40.3501 1029.63 59.6477C1029.63 59.6477 1046.6 76.6954 1043.38 79.5895C1043.38 79.5895 1099.67 138.85 1102.8 151.394C1102.8 151.394 1106.66 174.071 1107.63 214.356C1107.63 214.356 1114.14 222.798 1107.87 292.754H1107.87C1107.87 292.754 1113.42 300.473 1111.97 306.986C1110.52 313.5 1107.63 325.319 1102.81 330.145C1097.98 334.97 1085.03 344.699 1085.03 344.699C1085.03 344.699 1094.5 275.977 1069.74 242.848C1056.55 222.264 1012.81 213.257 990.457 241.421ZM990.457 241.421C990.404 204.481 978.873 159.955 975.022 150.006M990.457 241.421C990.406 204.481 978.873 159.955 975.022 150.006M975.022 150.006C971.164 140.035 954.759 131.673 954.759 131.673L952.572 126.785M602.776 353.585C604.102 357.808 603.299 382.734 600.927 386.332M602.776 353.585C602.157 351.618 602.214 348.601 602.214 348.601M602.776 353.585C602.159 351.62 602.214 348.601 602.214 348.601M602.214 348.601C608.969 213.996 601.577 170.875 595.017 162.895M602.214 348.601C608.969 213.996 601.575 170.875 595.017 162.895M595.017 162.895C592.31 159.6 592.691 146.752 592.691 146.752M806.082 317.259C808.976 332.376 807.369 364.54 805.439 376.118C807.369 364.54 808.978 332.376 806.082 317.259ZM806.082 317.259C803.188 302.142 807.047 296.352 807.047 296.352M806.082 317.259C803.186 302.142 807.047 296.352 807.047 296.352M807.047 296.352C816.695 240.387 813.157 161.264 812.192 156.441C811.228 151.617 802.141 140.279 802.141 140.279L801.579 135.534",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M952.571 126.784C939.372 129.699 592.746 146.887 592.746 146.887C596.204 127.991 659.887 33.5094 724.615 24.2633C724.615 24.2633 846.111 12.925 944.449 46.1346C944.449 46.1346 976.049 58.5987 990.523 85.374C990.523 85.374 978.784 120.995 952.571 126.784Z",
    fill: "#E6E6E6",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M914.709 330.31L612.435 346.451C612.435 346.451 638.925 308.137 660.138 304.915C681.368 301.694 857.942 285.93 857.942 285.93C882.239 283.719 914.709 330.31 914.709 330.31Z",
    fill: "#757575"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M914.709 330.32L612.435 346.461C612.435 346.461 641.855 320.913 655.032 319.302C668.225 317.708 859.278 297.763 870.21 302.578C881.142 307.41 914.709 330.32 914.709 330.32Z",
    fill: "#999999"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M623.229 96.7031V145.367C604.277 146.326 592.746 146.892 592.746 146.892C594.168 139.164 605.665 118.739 623.229 96.7031Z",
    fill: "#333333",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M809.397 135.694C800.059 136.191 790.583 136.688 781.073 137.202C780.662 64.6865 761.9 25.2071 760.563 22.5169C767.537 22.3798 775.351 22.3284 783.798 22.4312C785.511 27.2119 802.372 75.5673 809.397 135.694Z",
    fill: "#333333",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M952.577 126.786C951.052 127.128 945.089 127.642 935.716 128.311C925.795 100.106 881.382 36.2779 876.961 29.9551C883.232 30.9661 889.521 32.0798 895.826 33.3478C899.27 38.2828 937.292 93.2008 952.577 126.786Z",
    fill: "#333333",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1043.37 79.5859C1046.59 76.69 1029.63 59.6406 1029.63 59.6406C1024.44 54.0202 1013.83 48.6055 1001.39 43.7734C1004.08 45.9496 1021.47 60.3088 1040.1 82.1904L1043.37 79.5859Z",
    fill: "#1A1A1A",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1102.8 151.402L1098.9 152.858C1098.9 152.858 1095.36 142.887 1040.1 82.1914",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1102.8 151.407L1098.89 152.864C1098.89 152.864 1095.36 142.891 1040.1 82.1983L1043.37 79.5938C1043.37 79.5938 1099.66 138.864 1102.8 151.407Z",
    fill: "#4D4D4D",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1107.25 202.696C1098.51 200.211 1099.25 191.695 1099.25 191.695L1098.89 152.867L1102.8 151.41C1102.8 151.41 1105.93 169.728 1107.25 202.696Z",
    fill: "#F15A24",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.96 306.997C1110.53 313.508 1107.63 325.332 1102.8 330.147C1097.98 334.979 1085.03 344.712 1085.03 344.712C1085.03 344.712 1087.79 324.715 1086.43 301.103C1095.29 298.361 1107.87 292.758 1107.87 292.758C1107.87 292.758 1113.42 300.486 1111.96 306.997Z",
    fill: "#333333",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M329.528 185.117C329.528 185.117 427.251 140.231 566.101 133.53C576.423 133.031 587.761 133.132 598.644 133.031",
    fill: "#999999"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M957.272 332.449C957.083 337.915 956.227 350.715 952.166 366.976C952.166 366.976 947.248 386.681 941.473 386.921C935.682 387.161 568.194 405.084 568.194 405.084C568.194 405.084 575.963 384.659 576.597 373.401C576.751 370.728 577.414 363.566 577.603 353.816L603.08 352.908L612.436 346.448L914.711 330.307L919.508 334.625L957.272 332.449Z",
    fill: "#333333",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M568.217 405.096C568.217 405.096 571.087 397.3 573.942 387.259L951.805 368.324C950.588 372.745 946.339 386.727 941.473 386.933",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M904.804 19.1915C885.682 17.1696 779.669 6.66571 720.142 13.2285C704.156 14.9934 686.798 23.0812 669.681 34.2875C596.961 18.2148 433.94 29.2498 423.522 33.1052C498.761 0.428529 707.463 -13.1939 904.804 19.1915Z",
    fill: "#333333",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M669.681 34.2821C619.544 67.0959 571.464 126.76 566.101 133.529C449.499 137.007 258.686 133.443 255.447 133.375C256.904 132.312 345.696 66.9245 423.522 33.1169C423.574 33.0998 423.608 33.0826 423.659 33.0655C435.294 29.1587 597.269 18.2779 669.681 34.2821Z",
    fill: "#E6E6E6",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M215.686 228.479C215.686 228.479 225.577 235.434 236.793 239.677C260.432 240.16 318.809 235.576 318.809 235.576V243.779C341.483 244.262 371.395 241.608 371.395 241.608C388.04 229.547 416.746 200.117 416.746 200.117C415.781 198.429 409.51 196.498 409.51 196.498C387.559 196.498 341.968 204.217 341.968 204.217L330.711 212.098L215.686 222.867V228.479Z",
    fill: "#171717",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M312.112 219.75C302.772 220.439 293.631 221.145 285.038 221.828L282.586 225.692L282.51 231.025L308.437 229.171V224.327L312.112 219.75Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M285.038 221.82C275.763 222.559 267.136 223.268 259.627 223.901L257.096 228.58V232.835L282.509 231.017L282.584 225.684L285.036 221.82H285.038Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M259.627 223.902C242.522 225.341 231.204 226.37 231.204 226.37V229.264L239.566 234.089L257.095 232.835V228.58L259.626 223.9L259.627 223.902Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M357.766 206.101L341.685 217.679L338.027 222.141L337.385 227.087L336.781 238.183L365.969 237.7L367.417 220.332L388.162 203.928C377.307 203.205 357.768 206.1 357.768 206.1L357.766 206.101Z",
    fill: "#F2F2F2",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M341.685 217.68C331.906 218.314 321.906 219.015 312.112 219.738L308.437 224.314V229.159L337.384 227.089L338.027 222.143L341.685 217.681V217.68Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M566.1 133.53C576.422 133.031 587.76 133.132 598.643 133.031L566.1 133.53Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M566.1 133.53C576.422 133.031 587.76 133.132 598.643 133.031",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M225.143 311.895L320.187 289.701L342.539 328.298L263.739 356.602L225.143 311.895Z",
    fill: "#757575"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M264.825 355.31L341.734 327.971L361.676 327.328L361.354 351.451L264.825 355.31Z",
    fill: "#999999"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M245.844 261.751L353.795 256.1C358.63 255.846 362.734 259.608 362.9 264.448L365.553 341.123C365.877 350.48 358.704 358.4 349.36 359.005L271.574 364.032L264.824 355.318L348.288 349.528C348.288 349.528 359.384 346.633 358.901 333.607C358.418 320.581 355.042 264.616 355.042 264.616L260.162 268.636L245.844 261.751Z",
    fill: "#171717",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M365.294 333.724H345.38C342.774 333.724 340.324 332.543 338.663 330.535C329.805 319.826 318.765 297.498 315.672 291.085C315.115 289.932 314.817 288.682 314.819 287.402C314.827 279.368 315.631 271.086 316.354 265.24C316.871 261.062 320.295 257.851 324.498 257.632L353.802 256.1C358.637 255.846 362.741 259.609 362.907 264.448L365.294 333.724Z",
    fill: "#171717",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M359.058 278.9H339.52V283.966H359.058V278.9Z",
    fill: "#F2F2F2"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M358.583 301.244H340.324V306.309H358.583V301.244Z",
    fill: "#F2F2F2"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M406.92 380.965C405.309 389.326 401.128 399.933 395.988 402.195C390.83 404.44 370.577 413.281 342.904 411.037C315.249 408.792 231.939 404.114 209.75 403.806L39.9268 397.363C39.9268 397.363 9.85526 389.326 6.65106 384.494C3.42972 379.679 -0.751175 370.752 1.18506 362.064L4.86904 362.116C6.06847 370.632 11.7915 376.012 20.1019 376.424C24.1285 376.424 261.36 383.86 266.997 383.226C272.617 382.575 281.459 371.883 281.459 371.883C361.067 368.987 406.44 364.72 406.44 364.72C406.44 364.72 408.53 372.603 406.92 380.965Z",
    fill: "#333333",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M548.932 133.963C364.819 152.966 247.942 203.018 247.942 203.018C247.942 203.018 102.571 201.732 69.1237 200.43C35.6595 199.145 54.2507 179.697 54.2507 179.697C54.2507 179.697 76.92 145.923 255.43 133.38L255.447 133.363C258.532 133.432 431.73 136.67 548.932 133.963Z",
    fill: "#999999",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5078 209.145C6.86087 223.898 8.91704 236.149 8.91704 236.149C14.4858 237.195 27.731 238.48 27.731 238.48L35.4417 228.833L36.4012 221.167C25.0237 217.997 18.067 211.715 16.5078 209.145Z",
    fill: "#171717",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9324 213.471C7.24982 226.202 8.9119 236.106 8.9119 236.106C9.61442 236.243 10.4369 236.38 11.345 236.517L14.4464 227.813L28.2742 227.967L28.3427 225.157C28.3427 225.157 17.9933 219.896 13.9324 213.471Z",
    fill: "#F2F2F2",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M281.457 371.888C281.457 371.888 272.616 382.58 266.995 383.231C261.358 383.865 24.1269 376.429 20.1002 376.429C11.7899 376.017 6.06684 370.637 4.8674 362.121L6.95785 354.65C6.95785 354.65 8.57194 325.56 18.7706 305.263C21.3751 300.078 26.6646 296.793 32.4664 296.891L197.737 299.646C197.737 299.646 215.368 300.606 230.327 314.605C245.286 328.587 281.457 371.888 281.457 371.888Z",
    fill: "#1A1A1A",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M214.785 228.949C214.785 228.949 221.055 233.469 229.458 237.479L228.731 269.196C228.257 289.124 199.237 291.301 199.237 291.301C199.237 291.301 61.3913 288.405 48.2763 288.405C37.1199 288.405 27.8979 276.443 28.1755 264.864L28.1892 239.419L36.33 229.177C36.33 229.177 114.662 236.309 214.785 228.949Z",
    fill: "#757575"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0639 282.813C83.2957 276.569 131.945 249.917 164.503 238.261C164.767 238.167 164.943 238.537 164.701 238.683C154.03 245.06 102.363 275.412 72.3381 283.474C71.9285 283.584 71.6938 283.02 72.0639 282.813Z",
    fill: "#F2F2F2",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M114.253 279.355C121.619 279.355 127.59 271.366 127.59 261.511C127.59 251.655 121.619 243.666 114.253 243.666C106.886 243.666 100.915 251.655 100.915 261.511C100.915 271.366 106.886 279.355 114.253 279.355Z",
    fill: "#F4F4F3",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M114.252 275.026C119.551 275.026 123.847 269.084 123.847 261.753C123.847 254.423 119.551 248.48 114.252 248.48C108.952 248.48 104.656 254.423 104.656 261.753C104.656 269.084 108.952 275.026 114.252 275.026Z",
    fill: "#1A1A1A",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M610.965 366.163C610.965 366.163 616.433 373.24 621.578 375.49C621.578 375.49 794.938 363.267 901.076 359.409C901.076 359.409 907.991 353.86 910.243 348.07C910.243 348.07 677.061 365.277 610.965 366.162V366.163Z",
    fill: "#666666"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M806.847 295.893C806.847 295.893 802.986 301.683 805.882 316.799M805.882 316.799C808.776 331.916 807.169 364.08 805.24 375.658C807.169 364.08 808.778 331.916 805.882 316.799Z",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M602.214 348.598C602.214 348.598 602.159 351.617 602.776 353.582L602.214 348.598Z",
    fill: "#999999"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M602.214 348.598C602.214 348.598 602.159 351.617 602.776 353.582C604.102 357.804 603.298 382.731 600.927 386.329",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M1090.49 142.111C931.811 137.982 633.01 173.479 623.697 173.821C615.087 174.147 612.383 150.106 612.023 146.988L625.512 146.302L629.004 146.131L641.843 145.48C642.408 146.902 644.941 155.778 649.41 155.47C654.545 155.127 974.624 129.243 1084.21 134.315L1090.49 142.111Z",
    fill: "#757575"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M806.084 317.266C803.19 302.149 807.049 296.359 807.049 296.359C816.698 240.394 813.159 161.271 812.195 156.448C811.23 151.624 802.143 140.286 802.143 140.286L801.581 135.541",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M975.025 150.042C971.166 140.071 954.761 131.709 954.761 131.709L952.575 126.82",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6196 283.048L7.11317 323.675L1.18454 321.705V252.445C1.18454 252.445 1.47412 249.991 2.41996 246.84C4.81883 250.113 11.3455 260.036 11.6196 268.243C11.9452 278.216 11.6196 283.048 11.6196 283.048Z",
    fill: "#171717",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4212 295.775L8.85918 301.184C5.42537 300.91 3.02993 299.865 2.12692 299.402V294.33C3.19099 294.741 6.12104 295.74 9.4212 295.775Z",
    fill: "#F2F2F2"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8264 277.518C6.41078 277.484 3.17402 276.165 2.06711 275.633V269.311C3.95536 269.927 7.98718 271.093 10.7699 270.887C10.8264 273.543 10.8401 275.736 10.8264 277.518Z",
    fill: "#F2F2F2"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M660.999 129.644C660.999 129.644 638.645 149.586 641.541 154.25C644.435 158.915 653.763 161.97 663.251 156.663C672.738 151.356 686.57 129.002 686.57 129.002L665.986 123.051L661.001 129.644H660.999Z",
    fill: "#1A1A1A",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M642.666 121.286C642.666 121.286 648.456 93.4641 671.934 100.058C695.412 106.651 709.886 112.28 709.886 123.377C709.886 134.474 704.741 140.745 696.377 141.067C688.015 141.389 653.117 143.802 646.042 136.083C646.042 136.083 640.413 131.098 642.665 121.288L642.666 121.286Z",
    fill: "#757575",
    stroke: "black",
    strokeWidth: 1.375,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M708.413 129.253C706.754 136.22 702.714 139.899 696.384 140.134C688.023 140.444 653.506 142.856 646.43 135.146C646.43 135.146 642.972 132.09 643.052 125.014C646.205 125.579 674.829 130.624 708.413 129.253Z",
    fill: "#595959"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M1045.83 146.854C1045.83 146.854 1062.88 143.96 1077.03 145.245C1077.03 145.245 1085.79 166.875 1081.21 180.866C1081.21 180.866 1071.88 181.227 1066.5 179.62C1061.11 178.013 1045.83 153.328 1045.83 146.854Z",
    stroke: "black",
    strokeWidth: 0.6875,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUltimo);
export default __webpack_public_path__ + "static/media/ultimo.f889dfb4ee41dbca706e1357be871513.svg";
export { ForwardRef as ReactComponent };